/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unseated/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarUnseatedIcon from 'DesignSystem/Svgs/Tysiav2CalendarUnseatedIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Unseated({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/Unseated",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarUnseatedIcon
  viewPath={`${viewPath}/Tysiav2CalendarUnseatedIcon`}
 fill2={fill2}
/>
{children}
</React.Fragment>)
}